// extracted by mini-css-extract-plugin
export default {"container":"style_container__jwOw8","header":"style_header__kNgjO","text":"style_text__fIYaV","icon":"style_icon__6fb2g"};